import chroma from 'chroma-js';
import Site from './Site';

// Scale positions map each Tailwind shade step to a point on the
// chroma scale (0 = lightest, 0.5 = base color, 1 = darkest).
const SHADE_POSITIONS: Record<number, number> = {
    25:  0.03,
    50:  0.07,
    100: 0.13,
    200: 0.24,
    300: 0.37,
    400: 0.46,
    // 500 is always the raw input hex
    600: 0.56,
    700: 0.65,
    800: 0.76,
    900: 0.87,
    950: 0.93,
};

function generateShades(hex: string): Record<number, string> {
    const lightEnd = chroma(hex).set('hsl.l', 0.97).hex();
    const darkEnd  = chroma(hex).set('hsl.l', 0.08).hex();

    // domain([0, 0.5, 1]) pins the base color exactly at the midpoint
    const scale = chroma.scale([lightEnd, hex, darkEnd]).mode('lab').domain([0, 0.5, 1]);

    const shades: Record<number, string> = { 500: hex };
    for (const [shade, pos] of Object.entries(SHADE_POSITIONS)) {
        shades[Number(shade)] = scale(pos).hex();
    }
    return shades;
}

export function applySitePrimaryColor(): void {
    if (!window.s?.site) return;

    const hex = Site.getCurrentSite().getCustomizationValueByName('SitePrimaryColor');
    if (!hex) return;

    const shades = generateShades(hex);
    const root = document.documentElement;

    for (const [shade, color] of Object.entries(shades)) {
        root.style.setProperty(`--color-primary-${shade}`, color);
    }
}
